/**
 * SearchTrigger — button that opens the global search modal.
 * Shows a search icon with platform-appropriate keyboard shortcut hint.
 */
import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';
import { useGlobalSearch } from './GlobalSearchProvider';
import { cn } from '@/lib/utils';

interface SearchTriggerProps {
  className?: string;
}

export function SearchTrigger({ className }: SearchTriggerProps) {
  const { openSearch } = useGlobalSearch();
  const [isMac, setIsMac] = useState(false);

  useEffect(() => {
    setIsMac(navigator.platform?.toLowerCase().includes('mac') ?? false);
  }, []);

  return (
    <button
      onClick={openSearch}
      aria-label="Open search"
      className={cn(
        'relative flex items-center gap-2 px-3 py-2 rounded-input',
        'border border-border bg-background/60 text-muted-foreground',
        'hover:bg-accent hover:text-accent-foreground transition-colors',
        'touch-target text-xs',
        className,
      )}
    >
      <Search className="size-4" />
      <span className="hidden sm:inline text-eyebrow-sm">Search</span>
      <kbd className="hidden sm:inline font-sans text-[9px] px-1.5 py-0.5 rounded bg-muted border border-border">
        {isMac ? '⌘' : 'Ctrl'}K
      </kbd>
    </button>
  );
}
